import React from 'react';
import classNames from 'classnames';

import './SidebarLayout.scss';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const SidebarLayout: React.FC<Props> = ({ className, children, ...rest }) => (
  <div className={classNames('SidebarLayout', className)} {...rest}>
    {children}
  </div>
);
